import React from 'react';
import PropTypes from 'prop-types';
import {
  Textarea,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
} from '../../Shared';

import {
  textareaTheme
} from '../../lib/';


const formName = 'Project Details';

const defaultValues = {
  'Description': '',
};

const fields = [
  'Description',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (

    <Textarea
      textareaId='Description'
      textareaName='Description'
      register={register}
      formState={formState}
      label='Is there anything you would like to tell us about your project?'
      theme={textareaTheme}
    />
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };
